import { Fragment } from "react";
import { MessageDescriptor, useIntl } from "react-intl";
import { Icon } from "@tabler/icons-react";
import { classNames } from "@ct-react/core";
import "./stepper.scss";

type Props = {
  className?: string;
  steps: { icon: Icon, msg: MessageDescriptor }[];
  activeIndex?: number;
}

const Stepper = ({ className, steps, activeIndex = 0 }: Props) => {

  const intl = useIntl();
  const wrapperClasses = classNames("stepper-wrap", className);

  return (
    <div className={wrapperClasses}>
      {steps.map(({ icon: Icon, msg }, index) => (
        <Fragment key={index}>
          {index > 0 &&
            <div className={classNames("connector", { selected: index + 1 <= activeIndex })} />
          }
          <div className={classNames("one-step", { selected: index < activeIndex })}>
            <span className="badge"><Icon className="b-icon" /></span>
            <span className="label">{intl.formatMessage(msg)}</span>
          </div>
        </Fragment>
      ))}
    </div>);

}

export default Stepper;
